import { toPascalCase } from './formatters';

export function generateObjectWithPascalCaseKeys(object) {
  const pascalCaseObject = {};
  Object.keys(object).forEach(key => {
    pascalCaseObject[toPascalCase(key)] = object[key];
  });

  return pascalCaseObject;
}
